module.exports = __webpack_public_path__ + "static/media/arrow-up.af94add4.svg";